<terra-dialog-header>
  <div class="title">
    <h1>Add Recipient from List</h1>
  </div>
</terra-dialog-header>

<mat-dialog-content>
  <form [formGroup]="pageForm">
    <div class="actions">
      <div class="filter-bar">
        <mat-form-field appearance="outline" class="text-filter-wrapper remove-error-place">
          <input matInput formControlName="filter" class="lo_sensitive" placeholder="Search"/>
        </mat-form-field>

        <div class="tags-filter-wrapper" *ngIf="allTags$ | async as allTags">
          <mat-form-field appearance="outline" *ngIf="allTags" class="remove-error-place tags-filter-field">
            <mat-select matInput placeholder="Filter by tags" formControlName="tags" multiple>
              <mat-option *ngFor="let tag of allTags | keyvalue" [value]="tag.key">{{ tag.value }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-chip-grid class="terra-chip">
            <mat-chip *ngFor="let tag of (selectedTags$ | async)">
              {{ tag }}
            </mat-chip>
          </mat-chip-grid>
        </div>
      </div>
    </div>
  </form>

  <terra-recipient-contacts-display-table [selectMany]="false" (viewTransactionHistory)="openTransactionsHistoryModal($event)"></terra-recipient-contacts-display-table>
</mat-dialog-content>

<mat-dialog-actions>
  <button type="button" [disabled]="!(selectedRecipient$ | async)" mat-flat-button color="primary" class="save-button" [mat-dialog-close]="selectedRecipient$ | async">
    Add
  </button>
  <button type="button" mat-button class="cancel-button" [mat-dialog-close]="undefined">Cancel</button>
</mat-dialog-actions>
